export default "__VITE_ASSET__4qtd6kZC__"